import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { isUndefined } from 'util';
import { Acm } from '../../../models/loyalty-acm.model';
import { Card } from '../../../models/loyalty-card.model';
import { ExternalMovements, Movement } from '../../../models/loyalty-movement.model';
import { Reason } from '../../../models/loyalty-reason.model';
import { ApiMethods, PermissionConfiguration } from '../../../models/permission.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { LoyaltyAcmService } from '../../../services/loyalty/loyalty-acm.service';
import { LoyaltyMovementService } from '../../../services/loyalty/loyalty-movement.service';
import { LoyaltyParamsService } from '../../../services/loyalty/params.service';
import { LoyaltyReasonService } from '../../../services/loyalty/reason.service';
import { StoreCommonService } from '../../../services/store/store-common.service';
import { PermsService } from '../../../services/utils/perms.service';
import { CalendarTranslateService } from './../../../modules/UIKit/services/calendarTranslate.service';
import { CommonService } from './../../../services/utils/common.service';
// import * as moment from 'moment';

type AOA = ExternalMovements[];

@Component({
  selector: 'app-loyalty-movement',
  templateUrl: './loyalty-movement.component.html',
  styleUrls: ['./loyalty-movement.component.css']
})
export class LoyaltyMovementComponent implements OnInit {

  @ViewChild('table') table: KontableComponent;
  @ViewChildren('table') tableChildren: QueryList<KontableComponent>;

  columnsTitles: any;
  totalRecords = 0;
  movements: Array<Movement>;
  movementModal: Movement;
  showModalDelete: boolean;
  sortO: number;
  sortF: string;
  completeStore: Array<{ value: string, label: string }>;
  cards = new Map<string, Card>();
  listCards: Array<{ value: string, label: string }>;
  acms = new Map<string, Acm>();
  listAcm: Array<{ value: string, label: string, acm_type_id: string }>;
  reasons = new Map<string, Reason>();
  listReason: Array<{ value: string, label: string }>;
  listStatus: Array<{ value: string, label: string }>;
  selectFilter = KontableComponent.SelectFilter;
  customFilter = KontableComponent.CustomFilter;
  paginationType = KontableComponent.ServerPagination;

  model = {
    filterAcm: '',
    filterXactDate: null
  }

  // KS-7999 - valore selezionato nel lookup ricercabile del filtro Accumulatore
  filterAcmSelected: string = null;

  show = {
    datatable: false
  };

  newDataAvailable: boolean;
  viewImportDialog: boolean;
  minCharsParams: string;
  private lastLoadParam: { offset: number, limit: number, search?: Array<{ key: string, value: string }> };




  // Switch tra componenti generali e componenti specifici
  public customerMgPermission: boolean;
  public customerMgPermissionCheck: PermissionConfiguration;

  public hideBtnImportMovementPermission: boolean;
  public hideBtnImportMovementCheck: PermissionConfiguration;
  
  public customerHideInfoCheck: PermissionConfiguration;
  public customerHideInfoPermission: boolean;

  // Disabilita il filtraggio della table per singola colonna
  public staticTable = false;
  constructor(
    private translate: TranslateService,
    public movementService: LoyaltyMovementService,
    private router: Router,
    private storeService: StoreCommonService,
    private acmService: LoyaltyAcmService,
    private reasonService: LoyaltyReasonService,
    private srvCommon: CommonService,
    public srvCalTranslate: CalendarTranslateService,
    private permSrv: PermsService,
    private activatedRoute: ActivatedRoute,
    private paramsLoyService: LoyaltyParamsService
  ) {
    this.customerMgPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-mg',
      method: ApiMethods.GET
    };
    this.hideBtnImportMovementCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'hide_import_movement_btn',
      method: ApiMethods.GET
    };
    this.customerHideInfoCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'customer-hide-info',
      method: ApiMethods.GET
    };
   }

  ngOnInit() {
    this.sortO = 1;
    this.sortF = '';
    this.movements = [];
    this.completeStore = [];
    this.listCards = [];
    this.listAcm = [];
    this.listReason = [];
    this.listStatus = [];
    // Verifica delle permission
    this.permSrv.check(this.customerMgPermissionCheck).subscribe(res => { this.customerMgPermission = res; });
    this.permSrv.check(this.hideBtnImportMovementCheck).subscribe(res => {

      this.hideBtnImportMovementPermission = res;

     });
     this.permSrv.check(this.customerHideInfoCheck).subscribe(res => {
      this.customerHideInfoPermission = res;
      console.log(this.customerHideInfoPermission)
     });
     
 /*   this.permSrv.getLoyaltyPermission().subscribe((permissions: Permission[]) => {
      permissions.forEach((perm: Permission) => {
        switch (perm.operationName) {
          case 'card-table-static':
            if (perm.allowsGET) this.staticTable = true;
            break;
        }
      });
    });
*/
    //recupero parametro ricerca carte , numero minimo
    this.paramsLoyService.getParamByKey('MOVEMENT.MIN.SEARCH.BY.CARD').subscribe(res => {
      this.minCharsParams = res.param_code;
      if(!this.minCharsParams || this.minCharsParams.length <= 0)
        this.minCharsParams = '3';
      this.setVariable(this.minCharsParams);
    });
    
    this.completeStore.push({value: null, label: ''});
    this.listAcm.push({value: null, label: '', acm_type_id: null});
 
    this.listReason.push({value: null, label: ''});
    this.listStatus.push({value: null, label: ''});

    this.translate.get([
      'movement.acm_id',
      'movement.card_id',
      'movement.customer_id',
      'movement.reason_id',
      'movement.reasonDescription',
      'movement.division_id',
      'movement.card_no',
      'movement.store_id',
      'movement.storeDescription',
      'movement.term_id',
      'movement.cash_desk',
      'movement.xact_id',
      'movement.sequence_id',
      'movement.xact_date',
      'movement.xact_time',
      'movement.operator_id',
      'movement.value',
      'movement.value2',
      'movement.previous_balance',
      'movement.previous_balance_2',
      'movement.obj_code',
      'movement.object_value',
      'movement.title',
      'common.status',
      'common.all',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended',
    ]).subscribe((translations) => {

      this.columnsTitles = {
        acm_id: translations['movement.acm_id'],
        card_id: translations['movement.card_id'],
        customer_id: translations['movement.customer_id'],
        reason_id: translations['movement.reason_id'],
        reasonDescription: translations['movement.reasonDescription'],
        division_id: translations['movement.division_id'],
        card_no: translations['movement.card_no'],
        store_id: translations['movement.store_id'],
        storeDescription: translations['movement.storeDescription'],
        term_id: translations['movement.term_id'],
        cash_desk: translations['movement.cash_desk'],
        xact_id: translations['movement.xact_id'],
        sequence_id: translations['movement.sequence_id'],
        xact_date: translations['movement.xact_date'],
        xact_time: translations['movement.xact_time'],
        operator_id: translations['movement.operator_id'],
        value: translations['movement.value'],
        previous_balance: translations['movement.previous_balance'],
        obj_code: translations['movement.obj_code'],
        object_value: translations['movement.object_value'],
        movement: translations['movement.title'],
        status: translations['common.status'],
        notDeleted: translations['common.status_notDeleted'],
        onlyDeleted: translations['common.status_onlyDeleted'],
        onlySuspended: translations['common.status_onlySuspended']
      };

      this.listStatus.push({value: '0', label: this.columnsTitles.notDeleted});
      this.listStatus.push({value: '1', label: this.columnsTitles.onlyDeleted});
      this.listStatus.push({value: '2', label: this.columnsTitles.onlySuspended});

      let acmOb: Observable<any>;
      let storeOb: Observable<any>;
      let reasonO: Observable<any>;

      acmOb = this.acmService.list();
      storeOb = this.storeService.getList();
      reasonO = this.reasonService.list();

      Observable.zip(acmOb, storeOb, reasonO).subscribe(([resAcm, resStore,resReas]) => {

        for (const acm of resAcm.data) {
          this.listAcm.push({
            value: acm.acm_code ? acm.acm_code : null,
            label:  `${acm.acm_code} - ${acm.acmDescription}`,
            acm_type_id: acm.acm_type_id
          });
        }

        for (const store of resStore) {
          this.completeStore.push({
            value: store.id ? store.id : null,
            label: store.name ? store.name : ''
          });
        }
        if (this.listReason.length <= 1) {
          for (const reason of resReas.data) {
            this.reasons.set(reason.id.toString(), reason);
            this.listReason.push({
              value: reason.id.toString(),
              label: reason.description
            });
          }
        }

        this.show.datatable = true;

      });

    });

  }

  ngAfterViewInit(): void {
    let counter = 0;
    this.tableChildren.changes.subscribe((comps: QueryList<KontableComponent>) => {
      const movementTable = comps.first;
      // Recupero numero di carta ed inserimento nel relativo filtro in caso di movimento da scheda cliente
      if (this.activatedRoute.snapshot.queryParams['cardNumber'] && counter === 0) {
        const filterCardNumber = this.activatedRoute.snapshot.queryParams['cardNumber'];
        movementTable.filter.search['card_no'] = filterCardNumber;
        movementTable.filter.search.push({key: 'card_no', value: filterCardNumber, filterType: 'equals'});
        movementTable.refresh();
        counter++;
      }
    })
  }

  /*
  remove(movement: Movement) {
    this.showModalDelete = false;
    this.movementService.remove(movement.id).subscribe(() => {
      this.movements.splice(this.movements.indexOf(movement), 1);

      this.loadPage(this.lastLoadParam.offset, this.lastLoadParam.limit, this.lastLoadParam.search);
    });
  }
  */

  openDeleteModal(layout) {
    this.movementModal = layout;
    this.showModalDelete = true;
  }

  /* loadPage (offset: number, limit: number, search?: Array<{ key: string, value: string }>) {
    this.lastLoadParam = { offset: offset, limit: limit, search: search || null};

    let movementO: Observable<any>;
    let acmO: Observable<any>;
    let reasonO: Observable<any>;
    let storeO: Observable<any>;

    movementO = this.movementService.list(offset , limit, search);

    // Card = this.cardService.list();
    acmO = this.acmService.list();
    reasonO = this.reasonService.list();
    storeO = this.storeService.getList();
    Observable.zip(movementO, acmO, reasonO, storeO)
      .subscribe(([res, resAcm, resReason, resStore]) => {
        this.movements = [];
        if (this.listAcm.length <= 1) {
          for (const acm of resAcm.data) {
            this.acms.set(acm.id.toString(), acm);
            this.listAcm.push({
              value: acm.id.toString(),
              label: acm.description,
              acm_type_id: acm.acm_type_id
            });
          }
        }
        if (this.listReason.length <= 1) {
          for (const reason of resReason.data) {
            this.reasons.set(reason.id.toString(), reason);
            this.listReason.push({
              value: reason.id.toString(),
              label: reason.description
            });
          }
        }

        if (this.completeStore.length <= 1) {
          for (const store of resStore) {
            this.completeStore.push({
              value: store.id ? store.id : null,
              label: store.name ? store.name : ''
            });
          }
        }

        for (const singleMovement of res.data ) {
          this.movements.push({
              id: singleMovement.id,
              acm_id: isUndefined(this.acms.get(singleMovement.acm_id.toString())) ? '' : this.acms.get(singleMovement.acm_id.toString()).description,
              card_id: isUndefined(this.cards.get(singleMovement.card_id.toString())) ? '' : this.cards.get(singleMovement.card_id.toString()).card_no,
              customer_id: singleMovement.customer_id,
              reason_id: isUndefined(this.reasons.get(singleMovement.reason_id.toString())) ? '' : this.reasons.get(singleMovement.reason_id.toString()).description,
              qty: singleMovement.qty
          });
        }

        this.show.datatable = true;

      });
  }
 */
  onAddNew(event) {
    this.router.navigate(['/loyalty/movement/form/']);
  }

  onEdit(movement) {
    this.router.navigate(['/loyalty/movement/form/' + movement.id]);
  }

  onRemove(event) { }

  onClearFilters(event) {
    this.model.filterXactDate = null;
    this.filterAcmSelected = null;
  }

  onOpen(movement) {
    this.router.navigate(['/loyalty/movement/form/read/' + movement.id]);
  }

  /*
  onChangeChangeAcm($event) {

    let index = this.listAcm.findIndex(f => f.value === $event.value);

    if (index > -1) {
      this.listReason = [];
      let acmTypeId = this.listAcm[index].acm_type_id;

      this.acmTypeHasReasonService.getFromAcmType(acmTypeId).subscribe(resp => {
        if (resp.data && resp.data.length > 0) {

          this.listReason.push({label: '', value: null});
          for (const reason of resp.data) {
            this.listReason.push({value: reason.reason_id.toString() , label: reason.reasonDescription});
          }
        }

      });
    }
  }
  */

  goToImportMovement(){
    this.router.navigate(['/loyalty/movement/form-import-movement/']);
  }

  // onMovementFileUpload(event) {
  //   if (event.files.length !== 1) {
  //     throw new Error('Cannot use multiple files');
  //   }
  //   this.movementFile = event.files[0];
  // }

  // runImportMovement() {
  //   let imported = [];
  //   let errorCount = 0;
  //   this.viewImportDialog = false;

  //   const reader: FileReader = new FileReader();
  //   reader.onload = (e: any) => {

  //     /* read workbook */
  //     const bstr: string = e.target.result;
  //     const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary', cellDates: true});

  //     /* grab first sheet */
  //     const wsname: string = wb.SheetNames[0];
  //     const ws: XLSX.WorkSheet = wb.Sheets[wsname];

  //     /* save data */
  //     this.movementData = <AOA>(XLSX.utils.sheet_to_json(ws, {blankrows: true, defval: null}));

  //     const movementsObs: Observable<Movement>[] = [];

  //     this.movementData.forEach(row => {
  //       movementsObs.push(this.movementService.insertMovement(row));
  //     });

  //     // in questa fase useremo un banale ciclo in quanto il BE non è in grado di scodare richieste contemporanee.
  //     movementsObs.forEach( (call, i) => {

  //       // temporaneamente in attesa di soluzione migliore.
  //       setTimeout(() => {
  //         call.subscribe( movement => {
  //           if (movement.id) {
  //             imported.push(movement.id);
  //           }
  //         },
  //         () => {
  //           errorCount++;
  //         }).add(
  //         // "finally"
  //         () => {
  //           if (i === movementsObs.length - 1) {
  //             if ( imported.length > 0) {
  //               this.notifyService.add({severity: 'success', detail: 'Process has succesfully imported ' + imported.length + ' movements.'});
  //             }
  //             if (errorCount > 0) {
  //               this.notifyService.add({severity: 'error', detail: errorCount + ' movements was not imported.'})
  //             }
  //           }
  //         });
  //       }, 50);

  //     });

  //   };

  //   if (this.movementFile != null) {
  //     reader.readAsBinaryString(this.movementFile);
  //   }

  //   this.movementFile = null;
  // }

  onChangeXactDate(field) {
    if (this.model.filterXactDate) {
      this.table.updateTableFilter(field, this.srvCommon.fromDateToDBString(this.model.filterXactDate), 'equals');
    }
    /*else {
      let index = this.table.filter.search.findIndex(f => f.key === field);
      if (index > -1) {
        this.table.filter.search.splice(index, 1);
        this.table.refresh();
      }
    }*/
  }

  setVariable(value: string) {
    this.movementService.minChars = value;
    }
    
    getVariable(): string {
    return this.movementService.minChars;
    }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-movement/loyalty-movement.component.ts